import React from "react";

const Title = () => {
  return (
    <div className="title">
      <h1>CSS border radius visualizer and calculator</h1>
      {/* <h2>{props.title}</h2> */}
    </div>
  );
};

export default Title;
